<div class="db-benchmark-table" [ngClass]="{'hosted-layout': isHosted, 'top-border': !isHosted && userSubscription?.trialBoosterClient}">
  <div></div>
  <div *ngIf="isHosted" class="db-benchmark-table__header pt12 pb12">
    <h4>{{ 'text_websiteBenchmarks' |dbText }}</h4>
    <span>{{ 'text_websiteBenchmarksDesc' |dbText }}</span>
    <br>
    <a (click)="onRerun.emit()" [ngClass]="{'disabled': loading}">{{ 'text_reanalyzeButton' |dbText }}</a>
  </div>
  <ng-container *ngIf="!isHosted">
    <div class="db-benchmark-table__header">
      <h4 class="mb18">{{ 'text_currentHostingBenchmarks' |dbText }}</h4>
      <a (click)="onRerun.emit()" [ngClass]="{'disabled': loading}">{{ 'text_reanalyzeButton' |dbText }}</a>
    </div>
    <div class="db-benchmark-table__header">
      <h4 class="mb10">{{ companyName }} {{ 'text_hostingBenchmarks' |dbText }}</h4>
      <button class="ds-btn-green ds-btn-max ds-btn-small" (click)="onOptimize.emit()"
              *ngIf="!(userSubscription?.boosterProClient && ((userSubscription?.plan?.additionalDomainCount === userSubscription?.plan?.totalDomainCount) || (hostedCounts?.length < userSubscription?.plan?.additionalDomainCount) ))">
        <span>{{userSubscription?.trialBoosterClient ? 'Upgrade' : userSubscription?.boosterProClient ? 'Buy Now' : 'Optimize'}}</span>
      </button>
    </div>
  </ng-container>
  <div [ngClass]="{'merge-row': !isHosted}">
    <h4>{{ 'text_serverPerformanceBenchmark2' | dbText }} <i class="db-icon db-icon-info-lined" [dsTooltip]="'text_serverPerformanceBenchmark' | dbText" dsTooltipAlign="left"></i></h4>
    <p>{{'text_serverPerformanceBenchmarkDesc' | dbText }}</p>
  </div>
  <div>
    <db-benchmark-result [websiteId]="websiteId" [demoUser]="demoUser" [userSubscription]="userSubscription" [isHosted]="isHosted" [value]="benchmark?.serverPerformance" [isTime]="true" [loading]="loading"
                         [high]="benchmarkMetrics.HIGH_SERVER_PERFORMANCE"
                         [low]="benchmarkMetrics.LOW_SERVER_PERFORMANCE"></db-benchmark-result>
  </div>
  <div *ngIf="!isHosted">
    <db-benchmark-result [websiteId]="websiteId" [userSubscription]="userSubscription" [isHosted]="isHosted" [value]="10" [isTime]="true" [isCurrent]="false"
                         [compareValue]="benchmark?.serverPerformance"
                         [high]="benchmarkMetrics.HIGH_SERVER_PERFORMANCE"
                         [low]="benchmarkMetrics.LOW_SERVER_PERFORMANCE"></db-benchmark-result>
  </div>
  <div *ngIf="!isHosted" class="merge-column db-benchmark-table__scale">
    <span></span> <10s ({{ 'text_goodLower' | dbText }})
    <span class="yellow"></span> 10-14s ({{ 'text_averageLabel' | dbText }})
    <span class="red"></span> >14s ({{ 'text_poor' | dbText }})
  </div>
  <div [ngClass]="{'merge-row': !isHosted}">
    <h4>{{ 'text_wordPressPerformanceBenchmark' | dbText }}</h4>
    <p>{{ 'text_wordPressPerformanceBenchmarkDesc' | dbText }}</p>
  </div>
  <div>
    <db-benchmark-result [websiteId]="websiteId" [userSubscription]="userSubscription" [isHosted]="isHosted" [value]="benchmark?.wordpressPerformance" [isTime]="true" [loading]="loading"
                         [high]="benchmarkMetrics.HIGH_WORDPRESS_PERFORMANCE"
                         [low]="benchmarkMetrics.LOW_WORDPRESS_PERFORMANCE"></db-benchmark-result>
  </div>
  <div *ngIf="!isHosted">
    <db-benchmark-result [websiteId]="websiteId" [userSubscription]="userSubscription"  [isHosted]="isHosted" [value]="0.8" [isTime]="true" [isCurrent]="false"
                         [compareValue]="benchmark?.wordpressPerformance"
                         [high]="benchmarkMetrics.HIGH_WORDPRESS_PERFORMANCE"
                         [low]="benchmarkMetrics.LOW_WORDPRESS_PERFORMANCE"></db-benchmark-result>
  </div>
  <div *ngIf="!isHosted" class="merge-column db-benchmark-table__scale">
    <span></span> <0.8s ({{ 'text_goodLower' | dbText }})
    <span class="yellow"></span> 0.8s-1.4s ({{ 'text_averageLabel' | dbText }})
    <span class="red"></span> >1.4s ({{ 'text_poor' | dbText }})
  </div>
  <div>
    <h4>{{ 'text_phpVersion' | dbText }}</h4>
    <p>{{ 'text_directlyImpactsYourWebsitePerformance' | dbText }}</p>
  </div>
  <div>
    <db-benchmark-result [websiteId]="websiteId" [userSubscription]="userSubscription" [isHosted]="isHosted" [value]="benchmark?.phpVersion" [loading]="loading"
                         [high]="benchmarkMetrics.PHP_VERSION" [low]="benchmarkMetrics.PHP_VERSION"></db-benchmark-result>
  </div>
  <div *ngIf="!isHosted">
    <db-benchmark-result [websiteId]="websiteId" [userSubscription]="userSubscription" [isHosted]="isHosted" [value]="benchmarkMetrics.PHP_VERSION"
                         [compareValue]="benchmark?.phpVersion" [isCurrent]="false"
                         [high]="benchmarkMetrics.PHP_VERSION" [low]="benchmarkMetrics.PHP_VERSION"></db-benchmark-result>
  </div>
</div>
